import React from "react";

import type { WidgetState } from "widgets/BaseWidget";
import BaseWidget, {WidgetProps} from "widgets/BaseWidget";
import {WithMeta} from "../../../widgets/MetaHOC";
import AntdTable from "../component";
import {WIDGET_PADDING, WidgetType} from "../../../constants/WidgetConstants";
import contentConfig from "./propertyConfig/contentConfig";
import {getStyleConfig} from "./propertyConfig/styleConfig";
import {EventType} from "../../../constants/AppsmithActionConstants/ActionConstants";
import _ from "lodash";
import {AutocompletionDefinitions} from "../../../widgets/constants";
import {ExtraDef, generateTypeDef} from "../../../utils/autocomplete/dataTreeTypeDefCreator";
import {Stylesheet} from "../../../entities/AppTheming";
import {json2Array} from "../../../utils/widgetPropertyValueUtil";
import { __DEP_CFG__ } from "workers/common/DependencyMap/configUtils";
import isEqual from "fast-deep-equal/es6";
interface TableWidgetProps extends WidgetProps, WithMeta {

}
class TableWidget extends BaseWidget<TableWidgetProps, WidgetState> {
  constructor(props: TableWidgetProps) {
    super(props);
    this.updateWidgetProperty = this.updateWidgetProperty.bind(this);
  }
  static getPropertyPaneContentConfig() {
    return contentConfig;
  }

  static getPropertyPaneEventsConfig() {
    return super.getWidgetEvents("TableWidgetAntd");
  }
  static getPropertyPaneStyleConfig() {
    return getStyleConfig();
  }
  static getAutocompleteDefinitions(): AutocompletionDefinitions {
    return (widget: TableWidgetProps, extraDefsToDefine?: ExtraDef) => {
      const config = {
        currentItem: generateTypeDef(widget.currentItem, extraDefsToDefine),
        currPage: "number",
        pageSize: "number",
        selectId: "string",
        tableData: generateTypeDef(widget.tableData, extraDefsToDefine),
        // allData: generateTypeDef(widget.allData, extraDefsToDefine),  // 与 tableData属性功能重复，删除
      };
      return config;
    };
  }
  static getMetaPropertiesMap(): Record<string, any> {
    return {
      currentItem: {},
      currPage: 1,
      pageSize: 10
    };
  }
  static getDefaultPropertiesMap(): Record<string, any> {
    return {
      currentItem: {},
      // tableData: "mockData",  // 默认值已经有了
      // selectedIndex: "defaultSelectedKeys",
      bindData: null
    };
  }
  static getDerivedPropertiesMap() {
    return {
      currentItem: "{{this.currentItem}}",
      getSelectedRow: "{{this.currentItem}}",
      getSelectId: "{{this.currentItem.id}}",
      getSelectedRows: "{{this.selectedRows}}",
      getSelectIds: "{{this.selectedIndex}}",
      selectId: "{{this.currentItem.id}}",
      selectIds: "{{this.selectedIndex}}",
      primaryColor: "{{appsmith.theme.colors.primaryColor}}",
      backgroundColor: "{{appsmith.theme.colors.backgroundColor}}",
      //allData: "{{this.tableData}}",
      tableData: __DEP_CFG__,
    }
  }

  static getStylesheetConfig(): Stylesheet {
    return {
      borderRadius: "{{appsmith.theme.borderRadius.appBorderRadius}}",
      boxShadow: "{{appsmith.theme.boxShadow.appBoxShadow}}",
      accentColor: "{{appsmith.theme.colors.primaryColor}}",
    };
  }

  updateWidgetProperty(propertyName: string, propertyValue: any): void {
    super.updateWidgetProperty(propertyName, propertyValue);
  }
  getPaddingAdjustedDimensions = () => {
    // eslint-disable-next-line prefer-const
    let { componentHeight, componentWidth } = this.getComponentDimensions();
    // (2 * WIDGET_PADDING) gives the total horizontal padding (i.e. paddingLeft + paddingRight)
    componentWidth = componentWidth - 2 * WIDGET_PADDING;
    return { componentHeight, componentWidth };
  };

  //单元格点击事件
  onCellClick = (item:any, eventStr:any)=>{
    const {pushBatchMetaUpdates, commitBatchMetaUpdates} = this.props;
    if(!eventStr){
      pushBatchMetaUpdates('currentItem', item);
      if(!item.isRowSelectionDisabled){
        pushBatchMetaUpdates('selectedIndex', [item.id]);
      }
      commitBatchMetaUpdates();
      return ;
    }

    let cloneEventStr:any = _.cloneDeep(eventStr);
    let tableColumns = _.keys(this.props.tableColumns);
    let allRows:Record<string, unknown> = {};
    _.each(tableColumns, (i:string)=>{
      allRows[i] = '';
    })
    let rows:Record<string,unknown> = {
      ...allRows,
      ...item
    }

    const fn = (data:any)=>{
      _.each(data, (i:any)=>{
        if(i.type == 'action'&&i.actionConfig&&(i.actionConfig.apiParams||i.actionConfig.navigateParams)){
          _.each(rows, (v:any, k:any)=>{
            if(i.actionConfig.apiParams){
              i.actionConfig.apiParams = i.actionConfig.apiParams.replace(`currentItem.${k}`, `"${v}"`);
            }
            if(i.actionConfig.navigateParams){
              i.actionConfig.navigateParams = i.actionConfig.navigateParams.replace(`currentItem.${k}`, `"${v}"`);
            }
          })
        }
        if(i.type == 'action' && i.actionConfig.navigateURL){
          _.each(rows, (v:any, k:any)=>{
            i.actionConfig.navigateURL = i.actionConfig.navigateURL.replace(/\s/g, '').replace(`{currentItem.${k}}`, `${v}`);
          })

        }
        i.children&&fn(i.children);
      })
    };
    if(_.isString(cloneEventStr)){
      _.each(rows, (v:any, k:any)=>{
        cloneEventStr = cloneEventStr
          .replace(`/{currentItem.${k}}`, `/${v}`)
          .replace(`{currentItem.${k}}`, `'${v}'`)
          .replace(`currentItem.${k}`, `'${v}'`);
      })
    }else{
      fn(cloneEventStr.children);
    }


    pushBatchMetaUpdates('currentItem', item, {
      triggerPropertyName: "onClick",
      dynamicString: cloneEventStr,
      event: {
        type: EventType.ON_CLICK,
      },
    });
    if(!item.isRowSelectionDisabled){
      pushBatchMetaUpdates('selectedIndex', [item.id]);
    }
    commitBatchMetaUpdates();

    // setTimeout(()=>{
    //   super.executeAction({
    //     triggerPropertyName: "onClick",
    //     dynamicString: cloneEventStr,
    //     event: {
    //       type: EventType.ON_CLICK,
    //     },
    //   });
    // }, 600);
  }
  //currPage和pageSize 发生变化时
  paginationChange = (currPage:any, pageSize:any)=>{
    const {pushBatchMetaUpdates, commitBatchMetaUpdates} = this.props;
    if (!this.props.isDirty) {
      pushBatchMetaUpdates('isDirty', true);
    }
    pushBatchMetaUpdates('currPage', currPage);
    pushBatchMetaUpdates('pageSize', pageSize);
    commitBatchMetaUpdates();
    let _onLoad = this.props.onLoad||this.props.onLazyLoad;
    if(_onLoad){
      super.executeAction({
        triggerPropertyName: "onPaginationChange",
        dynamicString: _onLoad,
        event: {
          type: EventType.ON_CLICK,
        },
        globalContext: {
          widgetName: this.props.widgetName,
          triggerPropertyName: "onPaginationChange",
        }
      });
    }
  }
  //行选择change事件
  onRowSelection = (selectedRowKeys:any, selectedRows:any) =>{
    if (isEqual(this.props.selectedIndex, selectedRowKeys)) {
      return;
    }

    const {pushBatchMetaUpdates, commitBatchMetaUpdates} = this.props;
    pushBatchMetaUpdates('selectedRows', selectedRows);
    pushBatchMetaUpdates('selectedIndex', selectedRowKeys);
    commitBatchMetaUpdates();
  }
  //切换组件是否可拖拽
  toggleDrag = (disable: boolean) => {
    this.disableDrag(disable);
  }

  componentDidUpdate(prevProps: TableWidgetProps) {
    if (prevProps.isTree !== this.props.isTree && (this.props.onLoad || this.props.onLazyLoad)) {
      const globalContext = {
        widgetName: this.props.widgetName,
      };

      super.executeAction({
        triggerPropertyName: this.props.onLoad ? 'onLoad' : 'onLazyLoad',
        dynamicString: this.props.onLoad || this.props.onLazyLoad,
        event: {
          type: EventType.ON_LOAD,
        },
        globalContext
      });
    }
  }

  getPageView() {
    let allData:any = this.props.tableData;
    if (!this.props.onLazyLoad && !this.props.onLoad) {
      allData = this.props.mockData || [];
    }
    allData = json2Array(allData); // 转换为数组，表格需要

    const { componentHeight } = this.getPaddingAdjustedDimensions();
    return <AntdTable {...this.props}
                      allData={allData}
                      height={componentHeight}
                      onCellClick={this.onCellClick}
                      paginationChange={this.paginationChange}
                      onRowSelection={this.onRowSelection}
                      onToggleDrag={this.toggleDrag}
                      primaryColorTheme={this.props.primaryColor}
                      updateWidgetProperty={this.updateWidgetProperty}/>
  }
  static getWidgetType(): WidgetType {
    return "TABLE_WIDGET_ANTD";
  }

}

export default TableWidget;
